import gql from "graphql-tag";

export default gql`
  mutation SendFeedback($input: UserFeedbackInput!) {
    sendFeedback(input: $input)
  }
`;
